module.exports = __webpack_public_path__ + "img/8.bd52cfa6.png";